'use client';

import { useCurrentPath } from './useCurrentPath/useCurrentPath';

export const useQueryParams = <T extends Record<string, string>>(): T & {
    routerIsReady: boolean;
} => {
    const { isReady, searchParams } = useCurrentPath();

    const queryParams = searchParams ? Object.fromEntries(searchParams.entries()) : {};

    return {
        ...queryParams,
        routerIsReady: isReady,
    } as T & { routerIsReady: boolean };
};
